import { Component, Input } from "@angular/core";

/**
 * Loading indicator component
 */
@Component({
  selector: 'loading-indicator',
  templateUrl: './loading-indicator-component.html',
  styleUrls: ['./loading-indicator-component.scss']
})
export class LoadingIndicatorComponent {
  /**
   * Should show the loading indicator?
   */
  @Input() show = false;
}
